import { Shield, TrendingUp, Coins, Layers, ListFilter } from "lucide-react";

import { cn } from "@/lib/utils";

// FIN-4 — Filtro de classe (pills horizontais, single-select).
// "Todos" é o estado default — limpa filtro.

const PILLS = [
  { value: "Todos",          icon: ListFilter,   color: "text-foreground" },
  { value: "Renda Fixa",     icon: Shield,       color: "text-brand-green" },
  { value: "Renda Variável", icon: TrendingUp,   color: "text-brand-cyan" },
  { value: "Cripto",         icon: Coins,        color: "text-status-warning" },
  { value: "Outros",         icon: Layers,       color: "text-foreground-muted" },
];

export default function ClassFilterPills({ value, onChange }) {
  return (
    <div
      className="inline-flex flex-wrap gap-1.5 bg-surface-card-hover/40 border border-subtle rounded-lg p-1"
      role="group"
      aria-label="Filtro de classe"
      data-testid="invest-class-filter"
    >
      {PILLS.map(p => {
        const Icon = p.icon;
        const isActive = value === p.value;
        return (
          <button
            key={p.value}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(p.value)}
            className={cn(
              "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-caption font-medium transition-all duration-fast",
              isActive
                ? "bg-brand-cyan/15 border border-brand-cyan/40 text-brand-cyan"
                : "border border-transparent text-foreground-muted hover:bg-surface-card-hover hover:text-foreground",
            )}
            data-testid={`invest-filter-${p.value.toLowerCase().replace(/\s/g, "-")}`}
          >
            <Icon className={cn("w-3.5 h-3.5", isActive ? "" : p.color)} aria-hidden="true" />
            {p.value}
          </button>
        );
      })}
    </div>
  );
}
